import { Injectable } from '@angular/core';
import { ConstantsModule } from '../constants/constants.module';
import { Observable, Subject } from 'rxjs';
import {HttperrorhandlerService} from '../http/httperrorhandler.service';
import { HttpClient } from '@angular/common/http';
import { environment } from  'src/environments/environment';
import { catchError, map } from 'rxjs/operators';
import { Params } from '@angular/router';
import { UtilsService } from 'src/app/utils/utils.service';
import { isNullOrUndefined } from 'util';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  
  // private forecastDataUrl = 'http://heatwave-staging.vassarlabs.com/api/hw/getForecastData';
  // private heatWatchesCountUrl ='http://heatwave-staging.vassarlabs.com/api/getHeatWatchesCount';
  // private hwAccuracyDataUrl = 'http://heatwave-staging.vassarlabs.com/api/hw/getHWAccuracyData';

  urlConstants = environment.url;

  // Used for title in Stock Chart
  public message = new Subject<object>();

  constructor(
    private errorHandler: HttperrorhandlerService,
    private http: HttpClient,
    public gisUtils: UtilsService,
  ) { }

  setMessage(value: object) {
    //it is publishing this value to all the subscribers that have already subscribed to this message
    this.message.next(value);
  }

  // getSourceListForComponent(component): Observable<any> {
  //     return this.http.get<any>(this.urlConstants.PLAY_URL + "comm/src/" + component).pipe(
  //       map(data => data.sort((a, b) => (a.value > b.value) ? 1 : -1)),
  //       catchError(this.errorHandler.handleError('All Sources data for Components : ', []))
  //     );
  // }

  getSourceListForComponent(options): Observable<any> {
    return this.http.post<any>(this.urlConstants.PLAY_URL + "comm/getrankwisesource", options).pipe(
      catchError(this.errorHandler.handleError('All Sources data for Components : ', []))
    );
  }

  getSourceListForComponentGW(): Observable<any> {
    return this.http.get<any>(this.urlConstants.PLAY_URL + "comm/getrankwisesource/groundwater").pipe(
      catchError(this.errorHandler.handleError('All Sources data for Components : ', []))
    );
  }

  getLocationLevelForSourceAndComponent(options:object):Observable<any>{
    return this.http.post<any>(this.urlConstants.PLAY_URL + "comm/getLocTypes", options).pipe(
      catchError(this.errorHandler.handleError('Locations Level for Source Data request', []))
    );
  }

  getLocationLevelForSourceAndComponentGW(options:object):Observable<any>{
    return this.http.post<any>(this.urlConstants.PLAY_URL + "comm/getLocTypes", options).pipe(
      catchError(this.errorHandler.handleError('Locations Level for Source Data request', []))
    );
  }

  getDateRangeForComponent(component: string, source: string): Observable<any> {
    return this.http.get<any>(this.urlConstants.PLAY_URL + "comm/range2/" + component + "/" + source).pipe(
      catchError(this.errorHandler.handleError('Date range request for ' + component, []))
    );
  }

  getLocationHierarchy(options : object) : Observable<any> {
    return this.http.post<any>(this.urlConstants.PLAY_URL + "locations/allChildrenForParentChildType", options).pipe(
      catchError(this.errorHandler.handleError('All Locations Data request', []))
    );
  }

  getStockChartData(options : object) : Observable<any> {
    return this.http.post<any>(this.urlConstants.PLAY_URL + "rf/rfChart", options).pipe(
      catchError(this.errorHandler.handleError('Stock Chart Data request', []))
    );
  }

  getStockChartDataForReservoir(options : object) : Observable<any> {
    return this.http.post<any>(this.urlConstants.PLAY_URL + "reservoir/chart", options).pipe(
      catchError(this.errorHandler.handleError('Stock Chart Data request', []))
    );
  }

  getStockChartDataForTemperature(options : object) : Observable<any> {
    return this.http.post<any>(this.urlConstants.PLAY_URL + "temperature/chart/timerange", options).pipe(
      catchError(this.errorHandler.handleError('Stock Chart Data request', []))
    );
  }

  flattenObject(data) {
    return data.map((value, key) => this.flattenOneObject(value));
  }

  flattenOneObject(ob) {
    if (typeof ob === 'string') {
      return ob;
    }
    const toReturn = {};
    for (const i in ob) {
      if (!ob.hasOwnProperty(i)) { continue; }
      // tslint:disable-next-line: triple-equals
      if ((typeof ob[i]) == 'object' && !(ob[i] instanceof Array)) {
        const flatObject = this.flattenOneObject(ob[i]);
        for (const x in flatObject) {
          if (!flatObject.hasOwnProperty(x)) { continue; }
          toReturn[i + '.' + x] = flatObject[x];
        }
      } else {
        toReturn[i] = ob[i];
      }
    }
    return toReturn;
  }

  verifyAllParamsPresent(queryParams: Params, verificationArray: string[]) {
    let isAllPresent = true;
    verificationArray.forEach(value => {
      if (!isAllPresent) {
        return;
      }
      if (!queryParams.hasOwnProperty(value)) {
        isAllPresent = false;
      }
    });
    return isAllPresent;
  }

  public formQuerParamsVariables(parsedLocInfo?: any, userLocType?:any) {
    let locationInfo: any = {
      country: '',
      state: '',
      district: '',
      ada: '',
      krishibhavan:'',
      village: '',
      location: ''
    }
    let types: any = {
      pType: '',
      cType: ''
    }
    if (Object.keys(parsedLocInfo).length > 0) {
      if (parsedLocInfo.hasOwnProperty('country')) {
        if (parsedLocInfo.country.length > 0) {
          locationInfo.country = this.gisUtils.titleCase(parsedLocInfo.country[0].countryName) + '##' + parsedLocInfo.country[0].countryUUID;
          locationInfo.state = '';
          locationInfo.district = '';
          locationInfo.ada = '';
          locationInfo.krishibhavan = '';
          locationInfo.village = '';
          locationInfo.location = locationInfo.country;
          types.pType = 'COUNTRY';
          types.cType = 'STATE';
          if (parsedLocInfo.country[0].hasOwnProperty('state')) {
            if (parsedLocInfo.country[0].state.length > 0) {
              locationInfo.country = this.gisUtils.titleCase(parsedLocInfo.country[0].countryName) + '##' + parsedLocInfo.country[0].countryUUID;
              locationInfo.state = this.gisUtils.titleCase(parsedLocInfo.country[0].state[0].stateName) + '##' + parsedLocInfo.country[0].state[0].stateUUID;
              locationInfo.district = '';
              locationInfo.ada = '';
              locationInfo.krishibhavan = '';
              locationInfo.village = '';
              locationInfo.location = locationInfo.country + '&' + locationInfo.state;
              types.pType = 'STATE';
              types.cType = 'DISTRICT';
              if (parsedLocInfo.country[0].state[0].hasOwnProperty('district')) {
                if (parsedLocInfo.country[0].state[0].district.length > 0) {
                  locationInfo.country = this.gisUtils.titleCase(parsedLocInfo.country[0].countryName) + '##' + parsedLocInfo.country[0].countryUUID;
                  locationInfo.state = this.gisUtils.titleCase(parsedLocInfo.country[0].state[0].stateName) + '##' + parsedLocInfo.country[0].state[0].stateUUID;
                  locationInfo.district = this.gisUtils.titleCase(parsedLocInfo.country[0].state[0].district[0].districtName) + '##' + parsedLocInfo.country[0].state[0].district[0].districtUUID;
                  locationInfo.ada = '';
                  locationInfo.krishibhavan = '';
                  locationInfo.village = '';
                  locationInfo.location = locationInfo.country + '&' + locationInfo.state + '&' + locationInfo.district;
                  types.pType = 'DISTRICT';
                  types.cType = 'ADA';
                  if (parsedLocInfo.country[0].state[0].district[0].hasOwnProperty('ada')) {
                    if (parsedLocInfo.country[0].state[0].district[0].ada.length > 0) {
                      locationInfo.country = this.gisUtils.titleCase(parsedLocInfo.country[0].countryName) + '##' + parsedLocInfo.country[0].countryUUID;
                      locationInfo.state = this.gisUtils.titleCase(parsedLocInfo.country[0].state[0].stateName) + '##' + parsedLocInfo.country[0].state[0].stateUUID;
                      locationInfo.district = this.gisUtils.titleCase(parsedLocInfo.country[0].state[0].district[0].districtName) + '##' + parsedLocInfo.country[0].state[0].district[0].districtUUID;
                      locationInfo.ada = this.gisUtils.titleCase(parsedLocInfo.country[0].state[0].district[0].ada[0].adaName) + '##' + parsedLocInfo.country[0].state[0].district[0].ada[0].adaUUID;
                      locationInfo.krishibhavan = '';
                      locationInfo.village = '';
                      locationInfo.location = locationInfo.country + '&' + locationInfo.state + '&' + locationInfo.district + '&' + locationInfo.ada;
                      types.pType = 'ADA';
                      types.cType = 'KRISHIBHAVAN';
                      if (parsedLocInfo.country[0].state[0].district[0].ada[0].hasOwnProperty('krishibhavan')) {
                        if (parsedLocInfo.country[0].state[0].district[0].ada[0].krishibhavan.length > 0) {
                          locationInfo.country = this.gisUtils.titleCase(parsedLocInfo.country[0].countryName) + '##' + parsedLocInfo.country[0].countryUUID;
                          locationInfo.state = this.gisUtils.titleCase(parsedLocInfo.country[0].state[0].stateName) + '##' + parsedLocInfo.country[0].state[0].stateUUID;
                          locationInfo.district = this.gisUtils.titleCase(parsedLocInfo.country[0].state[0].district[0].districtName) + '##' + parsedLocInfo.country[0].state[0].district[0].districtUUID;
                          locationInfo.ada = this.gisUtils.titleCase(parsedLocInfo.country[0].state[0].district[0].ada[0].adaName) + '##' + parsedLocInfo.country[0].state[0].district[0].ada[0].adaUUID;
                          locationInfo.krishibhavan = this.gisUtils.titleCase(parsedLocInfo.country[0].state[0].district[0].ada[0].krishibhavan[0].krishibhavanName) + '##' + parsedLocInfo.country[0].state[0].district[0].ada[0].krishibhavan[0].krishibhavanUUID;
                          locationInfo.village = '';
                          locationInfo.location = locationInfo.country + '&' + locationInfo.state + '&' + locationInfo.district + '&' + locationInfo.ada + '&' + locationInfo.krishibhavan;
                          types.pType = 'KRISHIBHAVAN';
                          types.cType = 'VILLAGE';
                          if (parsedLocInfo.country[0].state[0].district[0].ada[0].krishibhavan[0].hasOwnProperty('village')) {
                            if (parsedLocInfo.country[0].state[0].district[0].ada[0].krishibhavan[0].village.length > 0) {
                              locationInfo.country = this.gisUtils.titleCase(parsedLocInfo.country[0].countryName) + '##' + parsedLocInfo.country[0].countryUUID;
                              locationInfo.state = this.gisUtils.titleCase(parsedLocInfo.country[0].state[0].stateName) + '##' + parsedLocInfo.country[0].state[0].stateUUID;
                              locationInfo.district = this.gisUtils.titleCase(parsedLocInfo.country[0].state[0].district[0].districtName) + '##' + parsedLocInfo.country[0].state[0].district[0].districtUUID;
                              locationInfo.ada = this.gisUtils.titleCase(parsedLocInfo.country[0].state[0].district[0].ada[0].adaName) + '##' + parsedLocInfo.country[0].state[0].district[0].ada[0].adaUUID;
                              locationInfo.krishibhavan = this.gisUtils.titleCase(parsedLocInfo.country[0].state[0].district[0].ada[0].krishibhavan[0].krishibhavanName) + '##' + parsedLocInfo.country[0].state[0].district[0].ada[0].krishibhavan[0].krishibhavanUUID;
                              locationInfo.village = this.gisUtils.titleCase(parsedLocInfo.country[0].state[0].district[0].ada[0].krishibhavan[0].village[0].villageName) + '##' + parsedLocInfo.country[0].state[0].district[0].ada[0].krishibhavan[0].village[0].villageUUID;
                              locationInfo.location = locationInfo.country + '&' + locationInfo.state + '&' + locationInfo.district + '&' + locationInfo.ada + '&' + locationInfo.krishibhavan + '&' + locationInfo.village;
                              types.pType = 'VILLAGE';
                              types.cType = 'FARM';
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return { locationInfo, types };
  }

  deepMerge(src: any, dest: any, options?: any): any {
    const result :any= {};
    // tslint:disable-next-line: forin
    for (const i in src) {
      const type = typeof src[i];
      if (!isNullOrUndefined(options) && !isNullOrUndefined(options.customMerge) && !isNullOrUndefined(options.customMerge[i])) {

        // tslint:disable-next-line: triple-equals
        if (options.customMerge[i] == 'dest') {
          result[i] = !isNullOrUndefined(dest[i]) ? dest[i] : null;
          // tslint:disable-next-line: triple-equals
        } else if (options.customMerge[i] == 'src') {
          result[i] = !isNullOrUndefined(src[i]) ? src[i] : null;
        } else {
          result[i] = options.customMerge[i](src[i], dest[i]);
        }
      } else if (!isNullOrUndefined(src) && !isNullOrUndefined(src[i]) && type == 'object' && !(src[i] instanceof Array)) {
        result[i] = (!isNullOrUndefined(dest) && !isNullOrUndefined(dest[i])) ? this.deepMerge(src[i], dest[i], options) : src[i];
      } else if (!isNullOrUndefined(src) && !isNullOrUndefined(src[i]) && src[i] instanceof Array) {
        if (!isNullOrUndefined(options) && !isNullOrUndefined(options.array) && options.array == 'merge') {
          result[i] = (!isNullOrUndefined(dest) && !isNullOrUndefined(dest[i]) && dest[i].length > 0) ? src[i].concat(dest[i]) : src[i];
        } else if (!isNullOrUndefined(options) && !isNullOrUndefined(options.array) && options.array == 'override') {
          result[i] = (!isNullOrUndefined(dest) && !isNullOrUndefined(dest[i])) ? dest[i] : src[i];
        } else {
          result[i] = (!isNullOrUndefined(dest) && !isNullOrUndefined(dest[i]) && dest[i].length > 0) ? src[i].concat(dest[i]) : src[i];
        }
      } else {
        result[i] = (!isNullOrUndefined(dest) && !isNullOrUndefined(dest[i])) ? dest[i] : src[i];
      }
    }
    for (const i in dest) {
      if (isNullOrUndefined(result[i])) {
        result[i] = dest[i];
      }
    }
    return result;
  }

  deepClone(object:any): any {
    if (this.isEmptyField(object)) {
      return;
    }
    if (Array.isArray(object)) {
      return object.slice();
    }
    const cloneObj :any= {};
    const attributes = Object.keys(object);
    for (const attribute of attributes) {
      const property = object[attribute];

      if (typeof property === 'object') {
        cloneObj[attribute] = this.deepClone(property);
      } else {
        cloneObj[attribute] = property;
      }
    }
    return cloneObj;
  }

  isEmptyField(value: any) {
    if (isNullOrUndefined(value) || value === '' || value === 'null') {
        return true;
    }
    return false;
}

}
